<template>
  <div v-if="activities.length > 0" class="timeline-container">
    <div
      v-for="(activity, index) in activities"
      class="timeline-item"
      :key="index"
    >
      <div class="timeline-tail"></div>
      <i class="time-line-icon iconfont" :class="getIconClass(activity.event_type)"></i>
      <div class="timeline-item-wrapper">
        <div class="content">{{ getI18nPropertyValue(activity, 'cn_description', 'description') }}</div>
        <div class="time">{{ activity.created_time|formatDateTime('YYYY/MM/DD HH:mm') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getI18nPropertyValue } from '@/i18n'

export default {
  props: {
    activities: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      getI18nPropertyValue
    }
  },
  computed: {

  },
  created () {

  },
  methods: {
    getIconClass (eventType) {
      if (eventType === 'APPLY_JOB') {
        return 'iconCRM-apply'
      } else if (eventType === 'SHARE_JOB') {
        return 'iconCRM-share'
      } else if (eventType === 'REFERRAL_CANDIDATE') {
        return 'iconCRM-referral'
      } else if (eventType === 'VIEW_MICROSITE_CAMPAIGN') {
        return 'iconCRM-viewmicrosite'
      } else if (eventType === 'VIEW_MICROSITE') {
        return 'iconCRM-viewmicrosite'
      } else if (eventType === 'VIEW_JOB_DETAIL') {
        return 'iconCRM-viewjob'
      } else if (eventType === 'VIEW_JOB_LIST') {
        return 'iconCRM-viewjob'
      } else if (eventType === 'VIEW_MICROSITE_JOB_LIST') {
        return 'iconCRM-viewjob'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.timeline-container {
  .timeline-item {
    position: relative;
    padding-bottom: 20px;

    &:last-child {
      .timeline-tail {
        display: none;
      }
    }

    .timeline-tail {
      position: absolute;
      left: 10px;
      top: 20px;
      padding: 5px 0;
      width: 1px;
      height: calc(100% - 20px);

      &::before {
        display: block;
        content: '';
        width: 1px;
        height: 100%;
        background-color: #3B86C6;
      }
    }

    .time-line-icon {
      position: absolute;
      width: 20px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 20px;
      color: #0096cc;
    }

    .timeline-item-wrapper {
      padding-left: 32px;

      .content {
        line-height: 20px;
      }

      .time {
        color: #909399;
      }
    }
  }
}
</style>
